import * as yup from 'yup'
import { TYPE_REQUIRED } from 'constants/errors'
import { basicCreditSchema } from 'schemas/creditFormSchema'
import { birthDateSchema } from 'helpers/schemaHelpers'
import { ObjectSchema } from 'yup'

export default yup.object().shape({
  first_name: yup.string().required(TYPE_REQUIRED),
  last_name: yup.string().required(TYPE_REQUIRED),
  birth_date: birthDateSchema,
  ssn: yup.string().required(TYPE_REQUIRED)
    .matches(/^[0-9]{9}$/, 'Must be 9 digits'),
}).concat(basicCreditSchema as ObjectSchema<any>)
